import { Control } from 'react-hook-form'

import { CustomerField } from 'ui/forms/fields/CustomerField'
import InvoiceDateFields from './InvoiceDateFields'
import InvoiceActionFields from './InvoiceActionFields'
import { Invoice } from 'types'
import { InvoiceFormValues } from './schema'

interface InvoiceMainDataFieldProps {
  control: Control<InvoiceFormValues>
  invoice: Invoice | null
}

const InvoiceMainDataField = ({
  control,
  invoice,
}: InvoiceMainDataFieldProps) => {
  return (
    <div>
      <h1>{invoice?.id ? `INVOICE-${invoice.id}` : 'New invoice'}</h1>
      <div>
        <CustomerField label='Customer' control={control} name={'customer'} />
      </div>
      <div className='mt-4'>
        <InvoiceDateFields control={control} />
      </div>
      <div className='mt-4'>
        <InvoiceActionFields control={control} />
      </div>
    </div>
  )
}

export default InvoiceMainDataField
